module.exports = __webpack_public_path__ + "static/media/Fault_selected.39411871.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/Fault_selected.svg
// module id = 1340
// module chunks = 0